import Default from './Default';

const AlertasDefault = Default;

export default AlertasDefault;
